import clsx from 'clsx';
import { memo, useLayoutEffect, useRef } from 'react';
import usePrevious from './use-previous';

function SingleOtpInputComponent({
  focus,
  className,
  warning,
  ...props
}: {
  focus?: boolean;
  className?: string;
  warning?: boolean;
  [props: string]: unknown;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const prevFocus = usePrevious(!!focus);

  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus) {
        inputRef.current.focus();
      }
      if (focus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [focus, prevFocus]);

  const classes = clsx(
    'border-2 font-semibold mx-1 otpInput outline-none rounded-lg text-1.46x1 text-center',
    className,
    !warning ? null : 'border-red-500',
  );

  return (
    <input
      data-browsing-ignore
      ref={inputRef}
      className={classes}
      {...props}
      type="text"
      inputMode="numeric"
    />
  );
}

const SingleOtpInput = memo(SingleOtpInputComponent);
export default SingleOtpInput;
